(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gardenia-business-christmas"] && !Shopify.designMode) return;
  try {
    
(function () {
  function rootFor(element){return element && element.closest('.gbx');}
  const orderByRoot=new WeakMap();
  function orderState(root){
    if(!root)return null;
    if(!orderByRoot.has(root))orderByRoot.set(root,new Map());
    return orderByRoot.get(root);
  }
  function selectedProducts(root){
    const order=orderState(root);
    return order?Array.from(order.values()):[];
  }
  function money(pence){
    return (pence/100).toLocaleString('en-GB',{style:'currency',currency:'GBP'});
  }
  function lineLabel(item){
    return item.title+(item.variant?' / '+item.variant:'');
  }
  function makeOrderButton(action,content,description){
    const button=document.createElement('button');
    button.type='button';
    button.className='gbx-order-line-control';
    button.dataset.gbxOrderAction=action;
    button.textContent=content;
    button.setAttribute('aria-label',description);
    return button;
  }
  function renderOrder(root,items){
    const area=root.querySelector('[data-gbx-order-builder]');
    if(!area)return;
    const count=items.reduce(function(total,item){return total+item.quantity;},0);
    const subtotal=items.reduce(function(total,item){return total+item.quantity*item.unit;},0);
    const label=area.querySelector('[data-gbx-order-count]');
    if(label)label.textContent=count+' '+(count===1?'item':'items');
    const empty=area.querySelector('[data-gbx-order-empty]');
    if(empty)empty.hidden=items.length>0;
    const list=area.querySelector('[data-gbx-order-list]');
    if(list){
      list.replaceChildren();
      items.forEach(function(item){
        const line=document.createElement('li');
        line.className='gbx-order-line';
        line.dataset.gbxOrderLine=item.id;
        const title=document.createElement('div');
        title.className='gbx-order-line-details';
        const heading=document.createElement('strong');
        heading.textContent=lineLabel(item);
        const price=document.createElement('small');
        price.textContent=money(item.unit)+' + VAT each (guide)';
        title.append(heading,price);
        const controls=document.createElement('div');
        controls.className='gbx-order-line-actions';
        controls.appendChild(makeOrderButton('decrease','−','Reduce '+lineLabel(item)));
        const qty=document.createElement('span');
        qty.className='gbx-order-line-quantity';
        qty.textContent=String(item.quantity);
        qty.setAttribute('aria-label','Quantity '+item.quantity);
        controls.appendChild(qty);
        const plus=makeOrderButton('increase','+','Increase '+lineLabel(item));
        plus.disabled=item.quantity>=100;
        controls.appendChild(plus);
        controls.appendChild(makeOrderButton('remove','Remove','Remove '+lineLabel(item)));
        const total=document.createElement('strong');
        total.className='gbx-order-line-total';
        total.textContent=money(item.unit*item.quantity);
        line.append(title,controls,total);
        list.appendChild(line);
      });
      list.hidden=items.length===0;
    }
    const footer=area.querySelector('[data-gbx-order-footer]');
    if(footer)footer.hidden=items.length===0;
    const price=area.querySelector('[data-gbx-order-total]');
    if(price)price.textContent=money(subtotal);
  }
  function invoiceDescription(item){
    return item.quantity+' x '+item.title+(item.variant?' / '+item.variant:'');
  }
  function recalculate(root){
    if(!root)return;
    const items=selectedProducts(root);
    renderOrder(root,items);
    const total=items.reduce((sum,item)=>sum+item.quantity,0);
    const subtotal=items.reduce((sum,item)=>sum+(item.unit*item.quantity),0);
    const counter=root.querySelector('[data-gbx-count]');
    if(counter)counter.textContent=total.toLocaleString('en-GB');
    const guide=root.querySelector('[data-gbx-guide]');
    if(guide)guide.textContent=(subtotal/100).toLocaleString('en-GB',{style:'currency',currency:'GBP'});
    const noun=root.querySelector('[data-gbx-count-noun]');
    if(noun)noun.textContent=total===1?'item':'items';
    root.querySelectorAll('[data-gbx-quote-summary]').forEach(function(el){el.hidden=total===0;});
    const notes=root.querySelector('textarea[name="contact[body]"]');
    if(notes)notes.required=items.length===0;
    const star=root.querySelector('[data-gbx-notes-required]');
    if(star)star.hidden=items.length>0;
    const date=root.querySelector('[data-gbx-requested-date]');
    if(date){
      date.required=items.length>0;
      const wreathSelected=items.some(function(item){return /wreath/i.test(item.title);});
      date.min=wreathSelected?'2026-11-19':'2026-11-01';
      if(wreathSelected&&date.value&&date.value<'2026-11-19'){
        date.setCustomValidity('Christmas wreath deliveries and collections begin 19 November 2026. Please choose a later date.');
      }else{ date.setCustomValidity(''); }
    }
    const dateStar=root.querySelector('[data-gbx-date-required]');
    if(dateStar)dateStar.hidden=items.length===0;
    const deliveryMethod=root.querySelector('[name="contact[Delivery arrangements]"]');
    const singleAddress=items.length>0&&deliveryMethod&&['Delivery to one address','Installation at business premises'].includes(deliveryMethod.value);
    ['contact[Postcodes]','contact[Delivery address]','contact[Delivery town]'].forEach(function(name){
      const input=root.querySelector('[name="'+name+'"]');
      if(input)input.required=!!singleAddress;
    });
    root.querySelectorAll('[data-gbx-address-required]').forEach(function(marker){marker.hidden=!singleAddress;});
    const details=root.querySelector('.gbx-extra-fields');
    if(details&&(items.length>0||singleAddress))details.open=true;
    const pay=root.querySelector('[data-gbx-payment]');
    if(pay&&!pay.dataset.gbxUserSelected){
      pay.value=items.length?'Invoice for payment on receipt':'Please advise';
    }
    const preview=root.querySelector('[data-gbx-items-preview]');
    const listing=root.querySelector('[data-gbx-items-list]');
    if(preview&&listing){
      while(listing.firstChild)listing.removeChild(listing.firstChild);
      items.forEach(function(item){
        const li=document.createElement('li');
        li.textContent=invoiceDescription(item);
        listing.appendChild(li);
      });
      preview.hidden=items.length===0;
    }
    return items;
  }
  document.addEventListener('input',function(event){
    if(event.target.matches('[data-gbx-qty]')){
      event.target.setCustomValidity('');
    }
  });
  document.addEventListener('change',function(event){
    if(event.target.matches('[data-gbx-variant-select], [name="contact[Delivery arrangements]"], [data-gbx-requested-date]'))recalculate(rootFor(event.target));
    if(event.target.matches('[data-gbx-payment]'))event.target.dataset.gbxUserSelected='true';
  });
  document.addEventListener('click',function(event){
    const invoiceCardLink=event.target.closest('[data-gbx-open-invoice]');
    if(invoiceCardLink){
      const card=invoiceCardLink.closest('.gbx-card');
      const picker=card&&card.querySelector('.gbx-quote-picker');
      if(picker){
        event.preventDefault();
        picker.open=true;
        const control=picker.querySelector('[data-gbx-variant-select], [data-gbx-qty]');
        if(control)control.focus({preventScroll:true});
        picker.scrollIntoView({behavior:'smooth',block:'center'});
      }
    }
    const choice=event.target.closest('[data-gbx-interest]');
    if(choice){
      const root=rootFor(choice),target=root&&root.querySelector('[data-gbx-service-input]');
      if(target){
        const existing=target.value.split(';').map(function(x){return x.trim();}).filter(Boolean);
        const name=choice.dataset.gbxInterest;
        if(name&&existing.indexOf(name)<0)existing.push(name);
        target.value=existing.join('; ');
        const message=root.querySelector('[data-gbx-interests-summary]');
        if(message){message.hidden=false;message.textContent='Interested in: '+existing.join(', ');}
      }
    }
    const add=event.target.closest('[data-gbx-add-order]');
    if(add){
      event.preventDefault();
      const root=rootFor(add);
      const picker=add.closest('.gbx-quote-picker');
      const field=picker&&picker.querySelector('[data-gbx-qty]');
      const selector=picker&&picker.querySelector('[data-gbx-variant-select]');
      const option=selector&&selector.selectedIndex>=0?selector.options[selector.selectedIndex]:null;
      const amount=Number(field&&field.value);
      if(!root||!field||!Number.isInteger(amount)||amount<1||amount>100){
        if(field){field.setCustomValidity('Please enter a quantity between 1 and 100.');field.reportValidity();}
        return;
      }
      field.setCustomValidity('');
      if(option&&option.disabled){
        const feedback=picker.querySelector('[data-gbx-add-feedback]');
        if(feedback){feedback.hidden=false;feedback.textContent='This size is currently unavailable. Choose another option or contact us for help.';}
        return;
      }
      const variant=option?(option.dataset.gbxVariantTitle||option.textContent||''):(field.dataset.gbxVariantTitle||'');
      const id=option?option.value:(field.dataset.gbxVariantId||'');
      const unit=Math.max(0,Number(option?option.dataset.gbxPence:field.dataset.gbxPence)||0);
      if(!id)return;
      const state=orderState(root);
      const previous=state.get(id);
      const next=(previous?previous.quantity:0)+amount;
      const feedback=picker.querySelector('[data-gbx-add-feedback]');
      if(next>100){
        if(feedback){feedback.hidden=false;feedback.textContent='Maximum 100 of this size per enquiry. Please contact us for larger quantities.';}
        return;
      }
      const item={
        id:id,
        title:field.dataset.title||'Christmas product',
        variant:variant==='Default Title'?'':variant,
        quantity:next,
        unit:unit
      };
      state.set(id,item);
      field.value='1';
      if(feedback){feedback.hidden=false;feedback.textContent='Added '+amount+' × '+lineLabel(item)+' to your order.';}
      const jump=picker.querySelector('[data-gbx-order-jump]');
      if(jump)jump.hidden=false;
      recalculate(root);
      return;
    }
    const orderAction=event.target.closest('[data-gbx-order-action]');
    if(orderAction){
      event.preventDefault();
      const root=rootFor(orderAction);
      const row=orderAction.closest('[data-gbx-order-line]');
      const state=orderState(root);
      const item=state&&row&&state.get(row.dataset.gbxOrderLine);
      if(!item)return;
      const action=orderAction.dataset.gbxOrderAction;
      if(action==='remove'||(action==='decrease'&&item.quantity===1)){
        state.delete(item.id);
      }else if(action==='decrease'){
        item.quantity-=1;
      }else if(action==='increase'){
        item.quantity=Math.min(100,item.quantity+1);
      }
      recalculate(root);
      const area=root.querySelector('[data-gbx-order-builder]');
      const refreshed=area&&Array.from(area.querySelectorAll('[data-gbx-order-line]')).find(function(x){return x.dataset.gbxOrderLine===item.id;});
      const nextControl=refreshed&&refreshed.querySelector('[data-gbx-order-action="'+action+'"]');
      if(nextControl){nextControl.focus({preventScroll:true});}
      else if(area){area.focus({preventScroll:true});}
      return;
    }
    const invoiceRoute=event.target.closest('[data-gbx-invoice-route]');
    if(invoiceRoute){
      const root=rootFor(invoiceRoute);
      const pay=root&&root.querySelector('[data-gbx-payment]');
      if(pay){pay.value='Invoice for payment on receipt';pay.dataset.gbxUserSelected='true';}
      const extra=root&&root.querySelector('.gbx-extra-fields');
      if(extra)extra.open=true;
    }
    const whatsapp=event.target.closest('[data-gbx-whatsapp]');
    if(whatsapp){
      const root=rootFor(whatsapp),phone=(whatsapp.dataset.phone||'').replace(/\D/g,'');
      if(!root||!phone)return;
      const lines=['Hello Gardenia, I would like to enquire about Christmas for our business.'];
      selectedProducts(root).forEach(function(item){lines.push(invoiceDescription(item));});
      const services=root.querySelector('[data-gbx-service-input]');
      if(services&&services.value)lines.push('Interested in: '+services.value);
      whatsapp.href='https://wa.me/'+phone+'?text='+encodeURIComponent(lines.join('\n'));
    }
  });
  document.addEventListener('invalid',function(event){
    const details=event.target.closest('.gbx-extra-fields');
    if(details&&!details.open)details.open=true;
  },true);
  document.addEventListener('submit',function(event){
    const form=event.target,root=rootFor(form);
    if(!root||!form.matches('form'))return;
    const lines=recalculate(root)||selectedProducts(root);
    const services=form.querySelector('[data-gbx-service-input]');
    const selected=form.querySelector('[data-gbx-order-lines]');
    const notes=form.querySelector('textarea[name="contact[body]"]');
    const dateField=form.querySelector('[data-gbx-requested-date]');
    if(lines.length&&(!dateField||!dateField.value)){
      event.preventDefault();
      if(dateField){dateField.required=true;dateField.reportValidity();dateField.focus();}
      return;
    }
    const refField=form.querySelector('[data-gbx-request-ref]');
    if(refField&&!refField.value){
      const randomPart=window.crypto&&window.crypto.getRandomValues
        ?Array.from(window.crypto.getRandomValues(new Uint8Array(5))).map(function(x){return x.toString(16).padStart(2,'0');}).join('')
        :Math.random().toString(36).slice(2,12);
      refField.value='CC26-'+new Date().toISOString().slice(0,10).replace(/-/g,'')+'-'+randomPart.toUpperCase();
    }
    const humanSummary=form.querySelector('[data-gbx-human-summary]');
    if(humanSummary){
      const valueOf=function(name){const el=form.querySelector('[name="contact['+name+']"]');return el?el.value.trim():'';};
      const readableDate=function(raw){
        const parts=String(raw||'').match(/^(\d{4})-(\d{2})-(\d{2})$/);
        if(!parts)return raw||'To confirm';
        const day=Number(parts[3]);
        const suffix=(day>=11&&day<=13)?'th':(day%10===1?'st':day%10===2?'nd':day%10===3?'rd':'th');
        const date=new Date(Date.UTC(Number(parts[1]),Number(parts[2])-1,day));
        const weekday=date.toLocaleDateString('en-GB',{weekday:'long',timeZone:'UTC'});
        const month=date.toLocaleDateString('en-GB',{month:'long',timeZone:'UTC'});
        return weekday+' '+day+suffix+' '+month+' '+parts[1];
      };
      const requested=lines.length?lines.map(function(item){return '  - '+invoiceDescription(item);}):['  - Bespoke Christmas enquiry - see notes'];
      const address=[valueOf('Delivery address'),valueOf('Delivery town'),valueOf('Postcodes')].filter(Boolean).join(', ');
      const invoiceAddress=[valueOf('Billing address'),valueOf('Billing town'),valueOf('Billing postcode')].filter(Boolean).join(', ');
      const overview=[
        'GARDENIA - CHRISTMAS FOR BUSINESS',
        'Request: '+(refField?refField.value:''),
        '',
        'PRODUCTS REQUESTED',
        ...requested,
        '',
        'DELIVERY / COLLECTION',
        'Preferred date: '+readableDate(dateField?dateField.value:''),
        'Arrangement: '+(valueOf('Delivery arrangements')||'To confirm'),
        address?'Address: '+address:'',
        '',
        'CUSTOMER',
        [valueOf('Company'),valueOf('name')].filter(Boolean).join(' - '),
        valueOf('email'),
        valueOf('phone'),
        valueOf('Accounts email')?'Accounts: '+valueOf('Accounts email'):'',
        invoiceAddress?'Billing: '+invoiceAddress:'',
        '',
        'STATUS: For Gardenia review - no invoice or payment issued.'
      ].filter(function(line,index,array){return line!==''||array[index-1]!=='';});
      humanSummary.value=overview.join('\n');
    }
    const payloadField=form.querySelector('[data-gbx-order-json]');
    if(payloadField){
      const fieldValue=function(selector){const e=form.querySelector(selector);return e?e.value.trim():'';};
      payloadField.value=JSON.stringify({
        schema:'gardenia_corporate_christmas_v1',
        reference:refField?refField.value:'',
        intent:lines.length?'invoice_request':'bespoke_enquiry',
        lines:lines.map(function(item){const numeric=String(item.id||'').replace(/^gid:\/\/shopify\/ProductVariant\//,'');return {variant_id:'gid://shopify/ProductVariant/'+numeric,variant_numeric_id:numeric,quantity:item.quantity,product:item.title,variant:item.variant};}),
        company:fieldValue('[name="contact[Company]"]'),
        contact_name:fieldValue('[name="contact[name]"]'),
        customer_email:fieldValue('[name="contact[email]"]'),
        customer_phone:fieldValue('[name="contact[phone]"]'),
        accounts_email:fieldValue('[name="contact[Accounts email]"]'),
        requested_date:dateField?dateField.value:'',
        delivery_method:fieldValue('[name="contact[Delivery arrangements]"]'),
        delivery_postcodes:fieldValue('[name="contact[Postcodes]"]'),
        delivery_address:fieldValue('[name="contact[Delivery address]"]'),
        delivery_city:fieldValue('[name="contact[Delivery town]"]'),
        billing_address:fieldValue('[name="contact[Billing address]"]'),
        billing_city:fieldValue('[name="contact[Billing town]"]'),
        billing_postcode:fieldValue('[name="contact[Billing postcode]"]'),
        service_interests:services?services.value:'',
        customer_notes:notes?notes.value.split('--- Gardenia selected products ---')[0].trim():'',
        payment_preference:fieldValue('[name="contact[Payment preference]"]'),
        purchase_order:fieldValue('[name="contact[PO reference]"]')
      });
    }
    if(selected){
      selected.value=lines.map(function(item){
        return invoiceDescription(item)+' | Variant: '+item.id;
      }).join('; ');
    }
    if(!notes)return;
    const marker='--- Gardenia selected products ---';
    const original=notes.value.split(marker)[0].trim();
    const summary=[];
    if(lines.length){
      summary.push('INVOICE REQUEST - CHRISTMAS PRODUCTS');
      lines.forEach(function(item){
        summary.push(invoiceDescription(item)+' | Shopify variant: '+item.id);
      });
    }
    if(services&&services.value)summary.push('Additional services: '+services.value);
    if(summary.length){
      notes.value=original+(original?'\n\n':'')+marker+'\n'+summary.join('\n');
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
(() => {
  if (window.gardeniaCollectionPriority) {
    window.gardeniaCollectionPriority.refresh();
    return;
  }

  const londonTime = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/London',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23'
  });

  const beforeCutoff = () => {
    let hour = 0;
    let minute = 0;

    londonTime.formatToParts(new Date()).forEach((part) => {
      if (part.type === 'hour') hour = Number(part.value);
      if (part.type === 'minute') minute = Number(part.value);
    });

    return (hour * 60) + minute < 16 * 60;
  };

  const priorityFor = (status, deliveryTodayActive) => {
    if (status === 'delivery-today') return deliveryTodayActive ? 0 : 1;
    if (status === 'available') return 1;
    if (status === 'coming-soon') return 2;
    return 3;
  };

  const sortGrid = (grid) => {
    if (!grid) return;

    const params = new URLSearchParams(window.location.search);
    if (params.has('sort_by')) return;

    const deliveryTodayActive = beforeCutoff();
    const items = Array.from(grid.children).filter((item) =>
      item.matches('[data-gardenia-product-status]')
    );

    const sorted = [...items].sort((a, b) => {
      const priorityDifference =
        priorityFor(a.dataset.gardeniaProductStatus, deliveryTodayActive) -
        priorityFor(b.dataset.gardeniaProductStatus, deliveryTodayActive);

      if (priorityDifference !== 0) return priorityDifference;

      return (
        Number(a.dataset.gardeniaOriginalPosition || 0) -
        Number(b.dataset.gardeniaOriginalPosition || 0)
      );
    });

    const changed = sorted.some((item, index) => item !== items[index]);
    if (changed) sorted.forEach((item) => grid.appendChild(item));
  };

  const refresh = (root = document) => {
    if (root instanceof Element && root.matches('#product-grid')) {
      sortGrid(root);
      return;
    }

    root.querySelectorAll?.('#product-grid').forEach(sortGrid);
  };

  let mutationTimer;

  const observer = new MutationObserver((mutations) => {
    const relevant = mutations.some((mutation) => {
      if (mutation.target instanceof Element && mutation.target.closest('#ProductGridContainer')) {
        return true;
      }

      return Array.from(mutation.addedNodes).some((node) => {
        if (!(node instanceof Element)) return false;
        return node.id === 'product-grid' || Boolean(node.querySelector?.('#product-grid'));
      });
    });

    if (!relevant) return;

    window.clearTimeout(mutationTimer);
    mutationTimer = window.setTimeout(() => refresh(), 50);
  });

  const init = () => {
    refresh();

    observer.observe(document.body, { childList: true, subtree: true });

    const delayToNextMinute = 60000 - (Date.now() % 60000) + 50;
    window.setTimeout(() => {
      refresh();
      window.setInterval(refresh, 60000);
    }, delayToNextMinute);

    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) refresh();
    });

    document.addEventListener('shopify:section:load', () => refresh());
    window.addEventListener('pageshow', () => refresh());
  };

  window.gardeniaCollectionPriority = { refresh };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
